const BarrierIcon = ({ strokeColor = '#808080' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #fcfcfc;
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
        }
        .cls-3, .cls-4 {
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 {
          fill: #fbfbfb;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
        }
      `}</style>
    </defs>
    <g id="Circles">
      <circle id="Grey_Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle id="White_Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>
    <g id="Shapes">
      <g id="Barrier">
        <path
          className="cls-5"
          d="M362.85,409.67c-9.93,6.1-19.26,12.09-28.88,17.55-4.18,2.37-5.55,5.07-5.53,9.93.23,47.04.14,94.08.14,141.12,0,13.48-4.46,18.14-18.04,18.17-33.49.08-66.97.08-100.45-.05-15.28-.06-19.72-4.78-19.73-20.21-.01-71.22-.05-142.45-.02-213.67.01-24.86,6.68-33.92,31.32-35.4,26.46-1.6,53.11-.38,79.66.08,9.96.17,18.43,4.38,24.27,13.67,57.62-34.61,114.93-69,172.2-103.44,20.08-12.08,40.07-24.31,60.13-36.42,7.33-4.43,15.86-2.67,20.72,4.96,8.04,12.65,15.87,25.46,23.21,38.52,6.08,10.83,2.46,21.43-9.67,28.72-24.15,14.52-48.55,28.65-72.77,43.06-52.06,30.98-104.07,62.05-156.58,93.41M304.61,572.12c.02-71.23-.05-142.46.22-213.69.02-6.53-2-8.01-8.13-7.93-24.71.34-49.44.43-74.15.05-6.79-.11-8.98,1.35-8.95,8.61.3,68.84.18,137.68.18,206.51v7.5c30.32,0,60.02,0,90.83-1.06M333.16,400.59c82.02-49.29,164.03-98.58,246.11-147.89-5.95-9.48-11.34-18.06-16.74-26.67-5.34,3.31-10,6.29-14.74,9.12-71.84,42.95-143.7,85.87-215.46,128.95-2.01,1.21-4.1,4.15-4.19,6.36-.44,10.57-.2,21.17-.2,32.43,1.77-.74,2.91-1.22,5.22-2.29h0Z"
        />
        <path
          className="cls-1"
          d="M252.5,389.78c11.04-3.2,21.37.67,26.44,9.56,5.19,9.1,3.13,19.85-5.18,27.06-7.86,6.82-18.9,7.09-27.62.68-7.75-5.71-11.29-17.17-6.44-25.4,2.77-4.69,8.03-7.9,12.79-11.89h0Z"
        />
      </g>
    </g>
  </svg>
);

export default BarrierIcon;